import type { UnsubscribeResponse, UnsubscribeParams } from '../types/unsubscribe';
import { wrapFetch } from '../libs/fetch';

export const postUnsubscribe = async (
  params: UnsubscribeParams,
  csrfToken: string
) => {
  return await wrapFetch<UnsubscribeResponse>('/api/v1/unsubscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(params),
    credentials: 'same-origin',
  });
};
